import beforeTruck from "@/assets/before-truck-debris.jpg";
import afterDebris from "@/assets/after-debris.jpg";
import baInteriorVacuum from "@/assets/ba-interior-vacuum.jpg";
import baInteriorPlastic from "@/assets/ba-interior-plastic.jpg";

type Row =
  | { type: "split"; before: string; after: string; caption: string }
  | { type: "combined"; image: string; caption: string };

const rows: Row[] = [
  {
    type: "split",
    before: beforeTruck,
    after: afterDebris,
    caption: "Debris Removal — Site Reset",
  },
  {
    type: "combined",
    image: baInteriorVacuum,
    caption: "Property Turnover — Move-In Ready",
  },
  {
    type: "combined",
    image: baInteriorPlastic,
    caption: "Final Detail — Completed Interior",
  },
];

export const ProofGrid = () => {
  return (
    <section id="proof" className="section-pad bg-warm-white text-charcoal">
      <div className="container-tight">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <h2 className="font-display text-3xl md:text-5xl text-charcoal">
            Real Jobs. Real Results.
          </h2>
        </div>

        <div className="space-y-10 md:space-y-14">
          {rows.map((row) => (
            <article
              key={row.caption}
              className="group border border-charcoal/10 overflow-hidden bg-warm-white animate-fade-in"
            >
              {row.type === "split" ? (
                <div className="grid grid-cols-1 md:grid-cols-2">
                  <div className="relative overflow-hidden aspect-[4/3] bg-charcoal/5">
                    <span className="absolute top-3 left-3 z-10 text-[10px] font-semibold uppercase tracking-[0.2em] bg-charcoal text-warm-white px-2 py-1">
                      Before
                    </span>
                    <img
                      src={row.before}
                      alt={`${row.caption} — before`}
                      loading="lazy"
                      className="h-full w-full object-cover transition-transform duration-700 ease-out lg:group-hover:scale-105"
                    />
                  </div>
                  <div className="relative overflow-hidden aspect-[4/3] bg-charcoal/5">
                    <span className="absolute top-3 left-3 z-10 text-[10px] font-semibold uppercase tracking-[0.2em] bg-brass text-charcoal px-2 py-1">
                      After
                    </span>
                    <img
                      src={row.after}
                      alt={`${row.caption} — after`}
                      loading="lazy"
                      className="h-full w-full object-cover transition-transform duration-700 ease-out lg:group-hover:scale-105"
                    />
                  </div>
                </div>
              ) : (
                <div className="relative overflow-hidden bg-charcoal/5">
                  <img
                    src={row.image}
                    alt={row.caption}
                    loading="lazy"
                    className="w-full h-auto object-cover transition-transform duration-700 ease-out lg:group-hover:scale-[1.02]"
                  />
                </div>
              )}
              <div className="px-5 py-4 border-t border-charcoal/10 text-center">
                <p className="font-display text-sm md:text-base uppercase tracking-wide text-charcoal">
                  {row.caption}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};
